import React from 'react';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { Box, Center, ListItem, UnorderedList } from '@televet/kibble-ui/build/chakra';
import { Heading } from '@televet/kibble-ui/build/components/Heading';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { ReactComponent as MoneyDog } from 'assets/images/money-dog.svg';
import { ReactComponent as PaymentHeaderImage } from 'assets/images/introducing-payments.svg';
import { useTracking } from 'shared/providers/TrackingProvider';
import { SettingsPaymentsEvents } from 'shared/providers/TrackingProvider/EventNames';
import { Alert } from '@televet/kibble-ui/build/components/Alert';

interface IPaymentsOnboardingProps {
  onSubmit: () => void;
  isLoading: boolean;
}

const PaymentsOnboarding = ({ onSubmit, isLoading }: IPaymentsOnboardingProps): JSX.Element => {
  const { trackEvent } = useTracking();

  const isClinicEligibleForPayments = true; // TODO: Replace with actual eligibility check after we have it defined again

  return (
    <Box className="InvoicingPanel__Onboarding" h="100vh" overflowY="scroll">
      <Box p={5} borderBottom="1px solid" borderColor="border.default">
        <Heading size="md">Payments</Heading>
      </Box>
      <PaymentHeaderImage />
      <Box>
        <Center w="100%">
          <MoneyDog style={{ width: 200, height: 180 }} />
        </Center>
      </Box>
      <Box px={5} h="50vh" pb="150px">
        <Box>
          <Text as="p" size="lg" fontWeight="bold" pb={2}>
            Complete Payment Solutions for your clinic.
          </Text>
          <Text as="p" size="sm" pb={2}>
            Give your clients in-clinic and contactless payment options, with no additional cost or effort for your
            team.
          </Text>
          <UnorderedList fontWeight="semibold" pb={2}>
            <ListItem fontSize="sm">
              Wi-Fi Terminals: Accept multiple forms of payment from any room in your clinic.
            </ListItem>
            <ListItem fontSize="sm">
              Text &amp; Chat to Pay: Accept payment without ever leaving the conversation.
            </ListItem>
            <ListItem fontSize="sm">Virtual Pay: Accept payment from wherever your client is.</ListItem>
          </UnorderedList>
          {isClinicEligibleForPayments ? (
            <Text as="p" size="sm" pb={4}>
              When you&apos;re ready, click the button below to complete your payment setup. Once you&apos;ve completed
              your profile in Stripe, return to Flow and refresh the page to gain full access to Otto&apos;s payment
              features.
            </Text>
          ) : (
            <Alert
              status="info"
              title="Onboarding not completed"
              description="Contact your Customer Success Representative to complete onboarding and begin processing payments."
              hideCloseButton
              mt={2}
            />
          )}
        </Box>
        <Center flexDirection="column" gap={3} mt={3}>
          {isClinicEligibleForPayments && (
            <Button onClick={onSubmit} isLoading={isLoading}>
              Set up Payments Now
            </Button>
          )}
          <Button
            variant="ghost"
            onClick={(): void => {
              if (window.zE) {
                window.zE('messenger', 'open');
              }
              trackEvent(SettingsPaymentsEvents.PaymentsSupportRequestInitiatedSidePanel);
            }}
          >
            Ask Us About Payments
          </Button>
        </Center>
      </Box>
    </Box>
  );
};

export default PaymentsOnboarding;
